export default {
  alphabeticalNameSorter(a, b) {
    let aName = a.properties && a.properties.name;
    let bName = b.properties && b.properties.name;

    if (aName && !bName) return -1;
    if (!aName && bName) return 1;
    if (!aName && !bName) return 0;
    return aName.localeCompare(bName);
  },
  alphabeticalDescNameSorter(a, b) {
    if (a.properties && !b.properties) return 1;
    if (!a.properties && b.properties) return -1;
    return b.properties.name.localeCompare(a.properties.name);
  },
  ascIdSorter(a, b) {
    return a.id > b.id ? 1 : b.id > a.id ? -1 : 0;
  },
  descIdSorter(a, b) {
    return a.id < b.id ? 1 : b.id < a.id ? -1 : 0;
  },
  createdAscSorter(a, b) {
    const date1 = Date.parse(a?.createdAt ?? '') || 0;
    const date2 = Date.parse(b?.createdAt ?? '') || 0;
    return date1 - date2;
  },
  createdDescSorter(a, b) {
    const date1 = Date.parse(a?.createdAt ?? '') || 0;
    const date2 = Date.parse(b?.createdAt ?? '') || 0;
    return date2 - date1;
  },
  updatedAscSorter(a, b) {
    const date1 = Date.parse(a?.updatedAt ?? '') || 0;
    const date2 = Date.parse(b?.updatedAt ?? '') || 0;
    return date1 - date2;
  },
  updatedDescSorter(a, b) {
    const date1 = Date.parse(a?.updatedAt ?? '') || 0;
    const date2 = Date.parse(b?.updatedAt ?? '') || 0;
    return date2 - date1;
  },
  sortFoldersAndFiles(deviceSort, folders, files) {
    if (deviceSort === 'a-z') {
      folders.sort(this.alphabeticalNameSorter);
      files.sort(this.alphabeticalNameSorter);
    } else if (deviceSort === 'z-a') {
      folders.sort(this.alphabeticalDescNameSorter);
      files.sort(this.alphabeticalDescNameSorter);
    } else if (deviceSort === 'id-asc') {
      folders.sort(this.ascIdSorter);
      files.sort(this.ascIdSorter);
    } else if (deviceSort === 'id-desc') {
      folders.sort(this.descIdSorter);
      files.sort(this.descIdSorter);
    } else if (deviceSort === 'created-desc') {
      folders.sort(this.createdDescSorter);
      files.sort(this.createdDescSorter);
    } else if (deviceSort === 'created-asc') {
      folders.sort(this.createdAscSorter);
      files.sort(this.createdAscSorter);
    } else if (deviceSort === 'updated-desc') {
      folders.sort(this.updatedAscSorter);
      files.sort(this.updatedAscSorter);
    } else if (deviceSort === 'updated-asc') {
      folders.sort(this.updatedAscSorter);
      files.sort(this.updatedAscSorter);
    } else {
      console.warn('Unknown sort method');
    }
  },
};
